var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sutl } from '../../../../sutl';
import { Timeouts } from '../framework/Timeouts';
import { EquipmentType, isLutronShadeControlConfig, isLutronShadePresetConfig } from '../Lutron';
var AreaAction;
(function (AreaAction) {
    AreaAction[AreaAction["Level"] = 1] = "Level";
    AreaAction[AreaAction["Raise"] = 2] = "Raise";
    AreaAction[AreaAction["Lower"] = 3] = "Lower";
    AreaAction[AreaAction["Stop"] = 4] = "Stop";
    AreaAction[AreaAction["CurrentScene"] = 6] = "CurrentScene";
})(AreaAction || (AreaAction = {}));
var DeviceAction;
(function (DeviceAction) {
    DeviceAction[DeviceAction["Press"] = 3] = "Press";
    DeviceAction[DeviceAction["Release"] = 4] = "Release";
    DeviceAction[DeviceAction["Hold"] = 5] = "Hold";
    DeviceAction[DeviceAction["CurrentScene"] = 7] = "CurrentScene";
    DeviceAction[DeviceAction["LightLevel"] = 14] = "LightLevel";
    DeviceAction[DeviceAction["Raise"] = 18] = "Raise";
    DeviceAction[DeviceAction["Lower"] = 19] = "Lower";
    DeviceAction[DeviceAction["Stop"] = 20] = "Stop";
})(DeviceAction || (DeviceAction = {}));
var OutputAction;
(function (OutputAction) {
    OutputAction[OutputAction["ZoneLevel"] = 1] = "ZoneLevel";
    OutputAction[OutputAction["Raise"] = 2] = "Raise";
    OutputAction[OutputAction["Lower"] = 3] = "Lower";
    OutputAction[OutputAction["Stop"] = 4] = "Stop";
    OutputAction[OutputAction["TiltLevel"] = 9] = "TiltLevel";
    OutputAction[OutputAction["TiltAndLiftLevel"] = 10] = "TiltAndLiftLevel";
    OutputAction[OutputAction["TiltRaise"] = 11] = "TiltRaise";
    OutputAction[OutputAction["TiltLower"] = 12] = "TiltLower";
    OutputAction[OutputAction["TiltStop"] = 13] = "TiltStop";
    OutputAction[OutputAction["LiftRaise"] = 14] = "LiftRaise";
    OutputAction[OutputAction["LiftLower"] = 15] = "LiftLower";
    OutputAction[OutputAction["LiftStop"] = 16] = "LiftStop";
})(OutputAction || (OutputAction = {}));
var ShadeGroupAction;
(function (ShadeGroupAction) {
    ShadeGroupAction[ShadeGroupAction["Level"] = 1] = "Level";
    ShadeGroupAction[ShadeGroupAction["Raise"] = 2] = "Raise";
    ShadeGroupAction[ShadeGroupAction["Lower"] = 3] = "Lower";
    ShadeGroupAction[ShadeGroupAction["Stop"] = 4] = "Stop";
    ShadeGroupAction[ShadeGroupAction["CurrentPreset"] = 6] = "CurrentPreset";
})(ShadeGroupAction || (ShadeGroupAction = {}));
export class Lutron {
    constructor(socket, log) {
        this.socket = socket;
        this.log = log;
        this.apiState = 'username';
        this.config = { equipmentId: '', equipmentType: '', ipAddress: '' };
        this.devices = [];
        this.timeouts = new Timeouts();
        this.values = {};
        this.apiAsyncHandlers = [
            {
                regExp: /(#|\?)AREA\s*,\s*(.+)/i,
                callback: (match) => {
                    var _a;
                    const op = match[1];
                    const args = match[2].split(/\s*,\s*/);
                    const id = ((_a = args.shift()) !== null && _a !== void 0 ? _a : '').toUpperCase();
                    const [action, param] = args.map(x => parseFloat(x));
                    if (this.config.equipmentType !== EquipmentType.QsStandalone &&
                        !this.devicesContainId(id)) {
                        this.socket.send('~Error,2');
                    }
                    else if (isNaN(action)) {
                        this.socket.send(`~Error,4`);
                    }
                    else if ((action === AreaAction.Raise ||
                        action === AreaAction.Lower ||
                        action === AreaAction.Stop) &&
                        op === '#' &&
                        param === undefined) {
                        this.socket.send(`~AREA,${id},${action}`);
                        return;
                    }
                    else if (action === AreaAction.Level) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setAreaLevel(id, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getAreaLevel(id);
                        }
                    }
                    else if (action === AreaAction.CurrentScene) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setAreaScene(id, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getAreaScene(id);
                        }
                    }
                    else {
                        this.socket.send(`~Error,6`);
                    }
                },
            },
            {
                regExp: /\?DETAILS\s*,\s*(.+)/i,
                callback: (match) => {
                    if (this.config.equipmentType === EquipmentType.QsStandalone) {
                        const arg = match[1].toUpperCase();
                        if (arg === 'ALL_DEVICES' || arg === 'FFFFFFFF') {
                            this.devices.forEach(dev => this.sendDetails(dev));
                        }
                        else {
                            this.devices.forEach(dev => {
                                if (dev.integrationId.toUpperCase() === arg) {
                                    this.sendDetails(dev);
                                }
                            });
                        }
                    }
                    else if (this.config.equipmentType === EquipmentType.RadioRa2) {
                        this.socket.send(`?DETAILS,${match[1]}`);
                        this.socket.send('is an unknown command');
                    }
                },
            },
            {
                regExp: /(#|\?)DEVICE\s*,\s*(.+)/i,
                callback: (match) => {
                    var _a;
                    const op = match[1];
                    const args = match[2].split(/\s*,\s*/);
                    const id = ((_a = args.shift()) !== null && _a !== void 0 ? _a : '').toUpperCase();
                    const [component, action, param] = args.map(x => parseFloat(x));
                    if (this.config.equipmentType !== EquipmentType.QsStandalone &&
                        !this.devicesContainId(id)) {
                        this.socket.send('~Error,2');
                    }
                    else if (isNaN(component) || isNaN(action)) {
                        this.socket.send(`~Error,4`);
                    }
                    else if ((action === DeviceAction.Press ||
                        action === DeviceAction.Release ||
                        action === DeviceAction.Hold) &&
                        op === '#' &&
                        param === undefined) {
                        this.socket.send(`~DEVICE,${id},${component},${action}`);
                    }
                    else if (action === DeviceAction.CurrentScene) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setDeviceScene(id, component, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getDeviceScene(id, component);
                        }
                    }
                    else if (action === DeviceAction.LightLevel) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setDeviceLevel(id, component, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getDeviceLevel(id, component);
                        }
                    }
                    else if (action === DeviceAction.Raise ||
                        action === DeviceAction.Lower ||
                        action === DeviceAction.Stop) {
                        this.socket.send(`~DEVICE,${id},${component},${action}`);
                    }
                    else {
                        this.socket.send('~Error,6');
                    }
                },
            },
            {
                regExp: /(#|\?)OUTPUT\s*,\s*(.+)/i,
                callback: (match) => {
                    var _a;
                    const op = match[1];
                    const args = match[2].split(/\s*,\s*/);
                    const id = ((_a = args.shift()) !== null && _a !== void 0 ? _a : '').toUpperCase();
                    const [action, param] = args.map(x => parseFloat(x));
                    if (this.config.equipmentType !== EquipmentType.QsStandalone &&
                        !this.devicesContainId(id)) {
                        this.socket.send('~Error,2');
                    }
                    else if (isNaN(action)) {
                        this.socket.send(`~Error,4`);
                    }
                    else if ((action === OutputAction.Raise ||
                        action === OutputAction.Lower ||
                        action === OutputAction.Stop ||
                        action === OutputAction.TiltRaise ||
                        action === OutputAction.TiltLower ||
                        action === OutputAction.TiltStop ||
                        action === OutputAction.LiftRaise ||
                        action === OutputAction.LiftLower ||
                        action === OutputAction.LiftStop) &&
                        op === '#' &&
                        param === undefined) {
                        this.socket.send(`~OUTPUT,${id},${action}`);
                    }
                    else if (action === OutputAction.ZoneLevel) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setOutputZoneLevel(id, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getOutputZoneLevel(id);
                        }
                    }
                    else if (action === OutputAction.TiltLevel) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setOutputTiltLevel(id, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getOutputTiltLevel(id);
                        }
                    }
                    else if (action === OutputAction.TiltAndLiftLevel) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setOutputTiltAndLiftLevel(id, param);
                        }
                        else {
                            if (this.checkGetParam(param))
                                this.getOutputTiltAndLiftLevel(id);
                        }
                    }
                    else {
                        this.socket.send(`~Error,6`);
                    }
                },
            },
            {
                regExp: /(#|\?)SHADEGRP\s*,\s*(.+)/i,
                callback: (match) => {
                    var _a;
                    const op = match[1];
                    const args = match[2].split(/\s*,\s*/);
                    const id = ((_a = args.shift()) !== null && _a !== void 0 ? _a : '').toUpperCase();
                    const [action, param] = args.map(x => parseFloat(x));
                    if (this.config.equipmentType !== EquipmentType.QsStandalone &&
                        !this.devicesContainId(id)) {
                        this.socket.send('~Error,2');
                    }
                    else if (isNaN(action)) {
                        this.socket.send(`~Error,4`);
                    }
                    else if ((action === ShadeGroupAction.Raise ||
                        action === ShadeGroupAction.Lower ||
                        action === ShadeGroupAction.Stop) &&
                        op === '#' &&
                        param === undefined) {
                        this.socket.send(`~SHADEGRP,${id},${action}`);
                    }
                    else if (action === ShadeGroupAction.CurrentPreset) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setShadeGroupPreset(id, param);
                        }
                        else {
                            if (this.checkGetParam(param)) {
                                const value = this.getShadeGroupPreset(id);
                                this.socket.send(`~SHADEGRP,${id},${action},${value}`);
                            }
                        }
                    }
                    else if (action === ShadeGroupAction.Level) {
                        if (op === '#') {
                            if (this.checkSetParam(param))
                                this.setShadeGroupLevel(id, param);
                        }
                        else {
                            this.socket.send(`~Error,6`);
                        }
                    }
                    else {
                        this.socket.send(`~Error,6`);
                    }
                },
            },
            {
                regExp: /\?SYSTEM,1/,
                callback: (match) => {
                    if (this.config.equipmentType === EquipmentType.RadioRa2) {
                        const date = new Date();
                        const time = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                        this.socket.send(`~SYSTEM,1,${time}`);
                    }
                    else {
                        this.socket.send('~Error,6'); // TODO: confirm error code
                    }
                },
            },
            {
                name: 'catchall',
                regExp: /.+/,
                callback: (match) => {
                    this.socket.send('~Error,6');
                },
            },
            {
                name: 'emptyCommand',
                regExp: /.*/,
                callback: (match) => {
                    // ignore
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.*/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`password: `);
                    }
                    else if (this.apiState === 'password') {
                        this.apiState = 'authenticated';
                        this.socket.send(`connection established`);
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
        this.commandExtractor = {
            allowEmptyCommands: true,
            terminators: ['\r', '\n'],
        };
    }
    onConfigure(config) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
            this.config = config;
            this.devices.length = 0;
            const deviceType = config.equipmentType === EquipmentType.QsStandalone
                ? 'qsStandalone'
                : config.equipmentType === EquipmentType.Quantum
                    ? 'quantum'
                    : 'radioRa2';
            for (const cfg of Object.values((_a = config === null || config === void 0 ? void 0 : config.lightingControls) !== null && _a !== void 0 ? _a : {})) {
                if (!this.devicesContainId(cfg.integrationId)) {
                    this.addDevice(deviceType, cfg.integrationId);
                }
                switch (cfg.type) {
                    case 'zone':
                        if (deviceType === 'qsStandalone') {
                            this.initializeDeviceLevel(cfg.integrationId, cfg.zoneNumber);
                        }
                        else {
                            this.initializeOutputZoneLevel(cfg.integrationId);
                        }
                        break;
                    default:
                        this.log.error(`unhandled lighting control config type`);
                        break;
                }
            }
            for (const cfg of Object.values((_b = config === null || config === void 0 ? void 0 : config.lightingPresets) !== null && _b !== void 0 ? _b : {})) {
                if (cfg.type === 'scene') {
                    if (!this.devicesContainId(cfg.integrationId)) {
                        this.addDevice('grafikEye', cfg.integrationId);
                    }
                }
                else if (cfg.type === 'phantomButton') {
                    if (!this.devicesContainId(cfg.integrationId)) {
                        this.addDevice(deviceType, cfg.integrationId);
                    }
                }
            }
            for (const cfg of Object.values((_c = config === null || config === void 0 ? void 0 : config.shadeControls) !== null && _c !== void 0 ? _c : {})) {
                if (!isLutronShadeControlConfig(cfg)) {
                    this.log.error(`invalid shade control config: ${JSON.stringify(cfg)}`);
                    continue;
                }
                if (!this.devicesContainId(cfg.integrationId)) {
                    this.addDevice(deviceType, cfg.integrationId);
                }
                switch (cfg.type) {
                    case 'lutronAreaRaiseLower':
                        this.initializeAreaLevel(cfg.integrationId);
                        break;
                    case 'lutronButtonPress':
                        break;
                    case 'lutronSceneControllerRaiseLower':
                        break;
                    case 'lutronOutputRaiseLower':
                        this.initializeOutputTiltAndLiftLevel(cfg.integrationId);
                        this.initializeOutputTiltLevel(cfg.integrationId);
                        this.initializeOutputZoneLevel(cfg.integrationId);
                        break;
                    case 'lutronShadeGroupRaiseLower':
                        this.initializeShadeGroupLevel(cfg.integrationId);
                        break;
                    default:
                        this.log.error(`unhandled shade control config type`);
                        break;
                }
            }
            for (const cfg of Object.values((_d = config === null || config === void 0 ? void 0 : config.shadePresets) !== null && _d !== void 0 ? _d : {})) {
                if (!isLutronShadePresetConfig(cfg)) {
                    this.log.error(`invalid shade preset config: ${JSON.stringify(cfg)}`);
                    continue;
                }
                if (!this.devicesContainId(cfg.integrationId)) {
                    this.addDevice(deviceType, cfg.integrationId);
                }
            }
            if (config.equipmentType === EquipmentType.QsStandalone) {
                if (!this.devicesContainType('qsStandalone')) {
                    this.addDevice('qsStandalone', 'nwk');
                }
                if (!this.devicesContainType('grafikEye')) {
                    this.addDevice('grafikEye', 'eye');
                }
            }
            else if (config.equipmentType === EquipmentType.Quantum) {
                if (!this.devicesContainType('quantum')) {
                    this.addDevice('quantum', 'quantum');
                }
            }
            else {
                if (!this.devicesContainType('radioRa2')) {
                    this.addDevice('radioRa2', 'ra');
                }
            }
            if (config.equipmentType === EquipmentType.Quantum) {
                this.apiState = 'username'; // do authentication for quantum
                this.asyncHandlers = this.authAsyncHandlers;
                try {
                    yield this.timeouts.delay(2000);
                }
                catch (error) { }
                this.socket.sendRaw(`login: `);
            }
            else {
                this.asyncHandlers = this.apiAsyncHandlers;
            }
        });
    }
    onDisconnect() {
        this.timeouts.clearAll();
    }
    addDevice(type, integrationId) {
        switch (type) {
            case 'grafikEye':
                this.devices.push({
                    boot: '4.2',
                    code: '9.17',
                    family: 'GRAFIK_EYE(2)',
                    hw: '2.1',
                    integrationId: integrationId.toUpperCase(),
                    product: 'QSG-ECO(2)',
                    serialNumber: '0x' + Sutl.generateRandomString(8, '0123456789abcdef'),
                    type,
                });
                break;
            case 'qsStandalone':
                this.devices.push({
                    boot: '2.13',
                    code: '8.74',
                    family: 'CONTROL_INTERFACE(6)',
                    hw: '1.1',
                    integrationId: integrationId.toUpperCase(),
                    product: 'QSE(1)',
                    serialNumber: '0x' + Sutl.generateRandomString(8, '0123456789abcdef'),
                    type,
                });
                break;
            case 'quantum':
                this.devices.push({
                    boot: '?',
                    code: '?',
                    family: '?',
                    hw: '?',
                    integrationId: integrationId.toUpperCase(),
                    product: '?',
                    serialNumber: '?',
                    type,
                });
                break;
            case 'radioRa2':
                this.devices.push({
                    boot: '?',
                    code: '?',
                    family: '?',
                    hw: '?',
                    integrationId: integrationId.toUpperCase(),
                    product: '?',
                    serialNumber: '?',
                    type,
                });
                break;
            case 'unknown':
            default:
                this.devices.push({
                    boot: '1.23',
                    code: '1.23',
                    family: 'UNKNOWN',
                    hw: '1.23',
                    integrationId: integrationId.toUpperCase(),
                    product: 'UNKNOWN',
                    serialNumber: 'UNKNOWN',
                    type,
                });
        }
    }
    checkGetParam(param) {
        if (param !== undefined) {
            this.socket.send(`~Error,6`);
            return false;
        }
        return true;
    }
    checkSetParam(param) {
        if (param === undefined) {
            this.socket.send(`~Error,6`);
            return false;
        }
        else if (isNaN(param)) {
            this.socket.send(`~Error,5`);
            return false;
        }
        return true;
    }
    devicesContainId(id) {
        return this.devices.find(dev => dev.integrationId === id) !== undefined;
    }
    devicesContainType(type) {
        return this.devices.find(dev => dev.type === type) !== undefined;
    }
    getAreaLevel(integrationId) {
        var _a;
        const key = `areaLevel.${integrationId}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~AREA,${integrationId},${AreaAction.Level},${value}`);
        return value;
    }
    getAreaScene(integrationId) {
        var _a;
        const key = `areaScene.${integrationId}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~AREA,${integrationId},${AreaAction.CurrentScene},${value}`);
        return value;
    }
    getDeviceLevel(integrationId, componentNumber) {
        var _a;
        const key = `deviceLevel.${integrationId}.${componentNumber}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~DEVICE,${integrationId},${componentNumber},${DeviceAction.LightLevel},${value}`);
        return value;
    }
    getDeviceScene(integrationId, componentNumber) {
        var _a;
        const key = `deviceScene.${integrationId}.${componentNumber}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~DEVICE,${integrationId},${componentNumber},${DeviceAction.CurrentScene},${value}`);
        return value;
    }
    getOutputTiltAndLiftLevel(integrationId) {
        var _a;
        const key = `outputTiltAndLiftLevel.${integrationId}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.TiltAndLiftLevel},${value}`);
        return value;
    }
    getOutputTiltLevel(integrationId) {
        var _a;
        const key = `outputTiltLevel.${integrationId}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.TiltLevel},${value}`);
        return value;
    }
    getOutputZoneLevel(integrationId) {
        var _a;
        const key = `outputZoneLevel.${integrationId}`;
        const value = (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.ZoneLevel},${value}`);
        return value;
    }
    getShadeGroupLevel(integrationId) {
        var _a;
        const key = `shadeGroupLevel.${integrationId}`;
        return (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
    }
    initializeAreaLevel(integrationId) {
        this.setAreaLevel(integrationId, this.getAreaLevel(integrationId));
    }
    initializeDeviceLevel(integrationId, componentNumber) {
        this.setDeviceLevel(integrationId, componentNumber, this.getDeviceLevel(integrationId, componentNumber));
    }
    initializeOutputTiltAndLiftLevel(integrationId) {
        this.setOutputTiltAndLiftLevel(integrationId, this.getOutputTiltAndLiftLevel(integrationId));
    }
    initializeOutputTiltLevel(integrationId) {
        this.setOutputTiltLevel(integrationId, this.getOutputTiltLevel(integrationId));
    }
    initializeOutputZoneLevel(integrationId) {
        this.setOutputZoneLevel(integrationId, this.getOutputZoneLevel(integrationId));
    }
    initializeShadeGroupLevel(integrationId) {
        this.setShadeGroupLevel(integrationId, this.getShadeGroupLevel(integrationId));
    }
    getShadeGroupPreset(integrationId) {
        var _a;
        const key = `shadeGroupPreset.${integrationId}`;
        return (_a = this.values[key]) !== null && _a !== void 0 ? _a : 0;
    }
    sendDetails(dev) {
        const str = '~DETAILS' +
            `,SN:${dev.serialNumber}` +
            `,INTEGRATIONID:${dev.integrationId}` +
            `,FAMILY:${dev.family}` +
            `,PRODUCT:${dev.product}` +
            `,CODE:${dev.code}` +
            `,BOOT:${dev.boot}` +
            `,HW:${dev.hw}`;
        this.socket.send(str);
    }
    setAreaLevel(integrationId, value) {
        const key = `areaLevel.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~AREA,${integrationId},${AreaAction.Level},${value}`);
    }
    setAreaScene(integrationId, value) {
        const key = `areaScene.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~AREA,${integrationId},${AreaAction.CurrentScene},${value}`);
        if (value >= 0 && value <= 4) {
            const level = value * 25;
            for (const key of Object.keys(this.values)) {
                const [control, id] = key.split('.');
                if (control === 'areaLevel') {
                    this.setAreaLevel(id, level);
                }
            }
        }
    }
    setDeviceLevel(integrationId, componentNumber, value) {
        const key = `deviceLevel.${integrationId}.${componentNumber}`;
        this.values[key] = value;
        this.socket.send(`~DEVICE,${integrationId},${componentNumber},${DeviceAction.LightLevel},${value}`);
    }
    setDeviceScene(integrationId, componentNumber, value) {
        const key = `deviceScene.${integrationId}.${componentNumber}`;
        this.values[key] = value;
        this.socket.send(`~DEVICE,${integrationId},${componentNumber},${DeviceAction.CurrentScene},${value}`);
        if (value >= 0 && value <= 4) {
            const level = value * 25;
            for (const key of Object.keys(this.values)) {
                const [control, id, component] = key.split('.');
                if (control === 'areaLevel') {
                    this.setAreaLevel(id, level);
                }
                else if (control === 'deviceLevel') {
                    this.setDeviceLevel(id, parseInt(component, 10), level);
                }
                else if (control === 'outputTiltAndLiftLevel') {
                    this.setOutputTiltAndLiftLevel(id, level);
                }
                else if (control === 'outputTiltLevel') {
                    this.setOutputTiltLevel(id, level);
                }
                else if (control === 'outputZoneLevel') {
                    this.setOutputZoneLevel(id, level);
                }
                else if (control === 'shadeGroupLevel') {
                    this.setShadeGroupLevel(id, level);
                }
            }
        }
    }
    setOutputTiltAndLiftLevel(integrationId, value) {
        const key = `outputTiltAndLiftLevel.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.TiltAndLiftLevel},${value}`);
    }
    setOutputTiltLevel(integrationId, value) {
        const key = `outputTiltLevel.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.TiltLevel},${value}`);
    }
    setOutputZoneLevel(integrationId, value) {
        const key = `outputZoneLevel.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~OUTPUT,${integrationId},${OutputAction.ZoneLevel},${value}`);
    }
    setShadeGroupLevel(integrationId, value) {
        const key = `shadeGroupLevel.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~SHADEGRP,${integrationId},${ShadeGroupAction.Level},${value}`);
    }
    setShadeGroupPreset(integrationId, value) {
        const key = `shadeGroupPreset.${integrationId}`;
        this.values[key] = value;
        this.socket.send(`~SHADEGRP,${integrationId},${ShadeGroupAction.CurrentPreset},${value}`);
    }
}
Lutron.emulatorType = 'socketEmulator';
Lutron.key = '-MDAF_dguZcRLLwbV5o5';
